import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

interface SelectTeamPayload {
    teamId: string;
    teamName: string;
}

const useSelectTeamsIntegrationTeam = () => {
    const userApi = useContainer(UserApi);

    const selectTeam = (body: SelectTeamPayload): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.selectTeamsIntegrationTeam({
                body,
                onSuccess: () => resolve(),
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { selectTeam };
};

export default useSelectTeamsIntegrationTeam;
